export const environment = {
  production: false,
  name: 'shipa',
  backendlessAPI:
    'https://api.testship.net/13BFF7C7-5671-EFB1-FFB0-7895530DFF00/3FF04A05-818B-4B00-9641-DF1A308C6E47/services',
};
